import { useState } from "react";
import { ResellerService } from "../../../services/ResellerService";
import { InputDefault } from "../../../components/forms/InputDefault";

export const ResellerCreate = ({ open, setOpen, refreshData }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    image: null,
    name: "",
    phone_number: "",
    joining_date: "",
  });

  const [error, setError] = useState({
    image: "",
    name: "",
    phone_number: "",
    joining_date: "",
  });

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.id]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    setError({
      image: "",
      name: "",
      phone_number: "",
      joining_date: "",
    });

    try {

      if (data.name.length < 1) {
        setError(prev => ({
          ...prev,
          name: "Nama tidak boleh kosong",
        }));
      } else if (data.phone_number.length > 1 && (data.phone_number.length < 10 || data.phone_number.length > 13)) {
        setError(prev => ({
          ...prev,
          phone_number: "Nomor telepon harus memiliki 10 digit",
        }));
      } else if (data.joining_date.length < 1) {
        setError(prev => ({
          ...prev,
          joining_date: "Tanggal bergabung tidak boleh kosong",
        }));
      } else {
        const res = await ResellerService.create({ data });
        setOpen(false);
        setData({
          image: null,
          name: "",
          phone_number: "",
          joining_date: "",
        });
        refreshData();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black p-5 ${open
        ? "bg-black/30 pointer-events-auto"
        : "bg-transparent pointer-events-none"
        }`}
    >
      <div
        className={` w-full max-w-[500px] bg-white shadow-xl rounded-xl flex flex-col gap-3 overflow-hidden transition-all duration-500 ${open ? "scale-100" : "scale-0"
          }`}
      >
        {/* Modal Header */}
        <div className="w-full flex items-center justify-center p-3 bg-gray-500 text-white">
          <p className="text-xl font-semibold">Tambah Data Reseller</p>
        </div>

        {/* Main Content */}
        <form
          onSubmit={handleSubmit}
          className="w-full p-3 flex flex-col gap-3"
        >
          {/* Form Data */}
          <InputDefault
            id="name"
            label="Nama"
            type="text"
            placeholder="Masukkan nama reseller"
            value={data.name}
            onChange={handleChange}
            error={error.name}
          />

          <InputDefault
            id="phoneNumber"
            label="Nomor Telepon"
            type="text"
            placeholder="Masukkan nomor telepon reseller"
            value={data.phone_number}
            onChange={(e) => setData({ ...data, phone_number: e.target.value })}
            error={error.phone_number}
          />

          <InputDefault
            id="joiningDate"
            label="Tanggal Bergabung"
            type="date"
            placeholder="Masukkan tanggal bergabung reseller"
            value={data.joining_date}
            onChange={(e) => setData({ ...data, joining_date: e.target.value })}
            error={error.joining_date}
          />

          {/* Button Submin n Cancel */}
          <div className="grid grid-cols-2 gap-3 text-white font-semibold">
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="bg-red-500 hover:bg-red-600 px-3 py-2 rounded-md"
            >
              Kembali
            </button>
            <button
              type="submin"
              className="bg-blue-500 hover:bg-blue-600 px-3 py-2 rounded-md"
            >
              {loading ? "Loading..." : "Simpan"}
            </button>
          </div>
        </form>

        {/* Footer */}
        <div className="w-full flex items-center justify-center p-3 bg-gray-500 text-white">
          <p className="text-xl font-semibold">Danela Net -||- Andri Studio</p>
        </div>
      </div>
    </div>
  );
};
